<template>
  <nav class="menu">
    <router-link
      :class="{'menu-active': menuActive('websites')}"
      @click.native="closeNav"
      :to="{name: 'websites', params: {companyId: currentUser.company_id}}"
    >
      <div>
        <Sprite name="logo" />
        <span>Websites</span>
      </div>
    </router-link>

    <div class="sub-menu">
      <router-link
        @click.native="closeNav"
        :to="{
          name: 'websites',
          params: {companyId: currentUser.company_id}
        }"
      >
        My Websites
      </router-link>

      <Permissions
        :permissions="currentUser.permissions"
        :requireAll="{site: ['create']}"
      >
        <router-link
          @click.native="closeNav"
          :to="{
            name: 'getStarted',
            params: {companyId: currentUser.company_id}
          }"
        >
          Create New Website
        </router-link>
      </Permissions>
    </div>

    <router-link
      v-if="companyOwner"
      :class="{'menu-active': menuActive('domains')}"
      @click.native="closeNav"
      :to="{
        name: 'company-domains',
        params: {companyId: currentUser.company_id}
      }"
    >
      <div>
        <Sprite name="domain" />
        <span>Domains Names</span>
      </div>
    </router-link>

    <div class="sub-menu" v-if="companyOwner">
      <router-link
        @click.native="closeNav"
        :to="{
          name: 'company-domains',
          params: {companyId: currentUser.company_id}
        }"
      >
        My Domain Names
      </router-link>

      <router-link
        @click.native="closeNav"
        :to="{
          name: 'domain-search',
          params: {companyId: currentUser.company_id}
        }"
      >
        Domain Name Search
      </router-link>
    </div>

    <router-link
      :class="{'menu-active': menuActive('team')}"
      @click.native="closeNav"
      :to="{name: 'company-users', params: {companyId: currentUser.company_id}}"
    >
      <div>
        <Sprite name="team" />
        <span>Team Members</span>
      </div>
    </router-link>

    <div class="sub-menu">
      <router-link
        @click.native="closeNav"
        :to="{name: 'company-users', params: {companyId: currentUser.company_id}}"
      >
        My Team
      </router-link>

      <Permissions
        :permissions="currentUser.permissions"
        :requireAll="{company_user: ['create']}"
      >
        <router-link
          @click.native="closeNav"
          :to="{name: 'add-company-user', params: {companyId: currentUser.company_id}}"
        >
          Invite Team Member
        </router-link>
      </Permissions>
    </div>

    <router-link
      v-if="companyOwner"
      :class="{'menu-active': menuActive('billing')}"
      @click.native="closeNav"
      :to="{name: 'billing', params: {companyId: currentUser.company_id}}"
    >
      <div>
        <Sprite name="coin" />
        <span>Billing Central</span>
      </div>
    </router-link>

    <div class="sub-menu" v-if="companyOwner">
      <router-link
        @click.native="closeNav"
        :to="{name: 'plans', params: {companyId: currentUser.company_id}}"
      >
        Plans
      </router-link>

      <router-link
        @click.native="closeNav"
        :to="{name: 'payment-methods', params: {companyId: currentUser.company_id}}"
      >
        Payment Methods
      </router-link>

      <router-link
        @click.native="closeNav"
        :to="{name: 'invoices', params: {companyId: currentUser.company_id}}"
      >
        Billing History
      </router-link>
    </div>

    <router-link @click.native="closeNav" :to="accountRoute">
      <div>
        <Sprite name="user" />
        <span>My Account</span>
      </div>
    </router-link>
  </nav>
</template>

<script>
import {mapState} from 'vuex'

import Sprite from '@/components/Sprite'
import Permissions from '@/components/Permissions'

export default {
  name: 'Navigation',

  props: {
    whiteLabel: Boolean
  },

  components: {
    Sprite,
    Permissions
  },

  computed: {
    ...mapState(['currentUser']),

    companyOwner() {
      return this.currentUser.owns_company && !this.whiteLabel
    },

    menuActive() {
      return (name) => {
        return this.$route.meta.menuName === name
      }
    },

    accountRoute() {
      const currentUser = this.currentUser

      if (currentUser && currentUser.company_id) {
        return {
          name: 'company-user',
          params: {companyId: currentUser.company_id, userId: currentUser.id}
        }
      } else {
        return {
          name: 'user',
          params: {userId: currentUser.id}
        }
      }
    }
  },

  methods: {
    closeNav() {
      this.$emit('closeNav')
    }
  }
}
</script>

<style lang="sass">
.menu
  margin: 0
  padding: 0
  list-style: none
  margin-top: 60px
  transition: opacity .2s .5s ease-in-out

  .sprite
    fill: #fff
    width: 20px
    height: 20px

  a
    display: flex
    flex-direction: column

    div
      display: flex
      align-items: center
      justify-content: flex-start
      flex-direction: row
      width: 100%

    &.is-active
      opacity: 1

  .menu-active
    opacity: 1

    + .sub-menu
      max-height: 300px
      overflow: auto

  .sub-menu
    background: rgba(0, 0, 0, 0.1)
    max-height: 0
    overflow: hidden
    transition: all .5s ease-in-out
</style>
